import { useFeatureGate } from '@statsig/react-bindings';
import { allFlags } from '../constants/featureFlags';

type FeatureFlags = (typeof allFlags)[number];
type Options = Parameters<typeof useFeatureGate>[1];
export const useFeatureFlag = (flag: FeatureFlags, options?: Options) =>
  useFeatureGate(flag, options);
